export const ALL_ITEM_AMULET = [
    {
      categry: "amulet",
      itemList: [
        {
          itemSelected: "fiamma",
          itemName: "Fiamma",
          itemDescription:
            "Fiamma is our custom-made amulet packaging designed to protect your amulets from damage and keep them safe and secure. We use a variety of materials to create a soft and cushioned interior lining. The sturdy exterior protects your amulets from bumps and shocks.",
            itemDescriptionList: [
              "Made in Thailand Craftsmanship",
              "Variety of World Class Materials",
              "Professional Consultation",
              "Fast Delivery",
            ],
          itemDesktopBig: [
            "/images/listItem/customizedProjects/Amulets/Desktop/Fiamma/700x700px/Lussopack-Packaging-Customized-Projects-Amulets-Fiamma-01.webp",          
            "/images/listItem/customizedProjects/Amulets/Desktop/Fiamma/700x700px/Lussopack-Packaging-Customized-Projects-Amulets-Fiamma-02.webp",                   
            "/images/listItem/customizedProjects/Amulets/Desktop/Fiamma/700x700px/Lussopack-Packaging-Customized-Projects-Amulets-Fiamma-03.webp",                   
            "/images/listItem/customizedProjects/Amulets/Desktop/Fiamma/700x700px/Lussopack-Packaging-Customized-Projects-Amulets-Fiamma-04.webp",                   
          ],
          itemDesktopSmall: [
            "/images/listItem/customizedProjects/Amulets/Desktop/Fiamma/130x130px/Lussopack-Packaging-Customized-Projects-Amulets-Fiamma-01.webp",
            "/images/listItem/customizedProjects/Amulets/Desktop/Fiamma/130x130px/Lussopack-Packaging-Customized-Projects-Amulets-Fiamma-02.webp",
            "/images/listItem/customizedProjects/Amulets/Desktop/Fiamma/130x130px/Lussopack-Packaging-Customized-Projects-Amulets-Fiamma-03.webp",
            "/images/listItem/customizedProjects/Amulets/Desktop/Fiamma/130x130px/Lussopack-Packaging-Customized-Projects-Amulets-Fiamma-04.webp",
          ],
          itemMobileBig: [
            "/images/listItem/customizedProjects/Amulets/Mobile/Fiamma/335x335px/Lussopack-Packaging-Customized-Projects-Amulets-Fiamma-01.webp",
            "/images/listItem/customizedProjects/Amulets/Mobile/Fiamma/335x335px/Lussopack-Packaging-Customized-Projects-Amulets-Fiamma-02.webp",
            "/images/listItem/customizedProjects/Amulets/Mobile/Fiamma/335x335px/Lussopack-Packaging-Customized-Projects-Amulets-Fiamma-03.webp",
            "/images/listItem/customizedProjects/Amulets/Mobile/Fiamma/335x335px/Lussopack-Packaging-Customized-Projects-Amulets-Fiamma-04.webp",
          ],
          itemMobileSmall: [
            "/images/listItem/customizedProjects/Amulets/Mobile/Fiamma/100x100px/Lussopack-Packaging-Customized-Projects-Amulets-Fiamma-01.webp",
            "/images/listItem/customizedProjects/Amulets/Mobile/Fiamma/100x100px/Lussopack-Packaging-Customized-Projects-Amulets-Fiamma-02.webp",
            "/images/listItem/customizedProjects/Amulets/Mobile/Fiamma/100x100px/Lussopack-Packaging-Customized-Projects-Amulets-Fiamma-03.webp",
            "/images/listItem/customizedProjects/Amulets/Mobile/Fiamma/100x100px/Lussopack-Packaging-Customized-Projects-Amulets-Fiamma-04.webp",
          ],
        },
        {
          itemSelected: "micio",
          itemName: "Micio",
          itemDescription:
            "Micio is our custom-made amulet packaging designed  to protect your amulets from damage and keep them safe and secure. We use a variety of materials to create a soft and cushioned interior lining. The sturdy exterior protects your amulets from bumps and shocks.",
          
            itemDescriptionList: [
              "Made in Thailand Craftsmanship",
              "Variety of World Class Materials",
              "Professional Consultation",
              "Fast Delivery",
            ],  itemDesktopBig: [
            "/images/listItem/customizedProjects/Amulets/Desktop/Micio/700x700px/Lussopack-Packaging-Customized-Projects-Amulets-Micio.webp",                            
          ],
          itemDesktopSmall: [
            "/images/listItem/customizedProjects/Amulets/Desktop/Micio/130x130px/Lussopack-Packaging-Customized-Projects-Amulets-Micio.webp",
          ],
          itemMobileBig: [
            "/images/listItem/customizedProjects/Amulets/Mobile/Micio/335x335px/Lussopack-Packaging-Customized-Projects-Amulets-Micio.webp",
          ],
          itemMobileSmall: [
            "/images/listItem/customizedProjects/Amulets/Mobile/Micio/100x100px/Lussopack-Packaging-Customized-Projects-Amulets-Micio.webp",
          ],
        },
        {
          itemSelected: "piccolo",
          itemName: "Piccolo",
          itemDescription:
            "Piccolo is our custom-made amulet packaging designed  to protect your amulets from damage and keep them safe and secure. We use a variety of materials to create a soft and cushioned interior lining. The sturdy exterior protects your amulets from bumps and shocks.",
          
            itemDescriptionList: [
              "Made in Thailand Craftsmanship",
              "Variety of World Class Materials",
              "Professional Consultation",
              "Fast Delivery",
            ],  itemDesktopBig: [
            "/images/listItem/customizedProjects/Amulets/Desktop/Piccolo/700x700px/Lussopack-Packaging-Customized-Projects-Amulets-Piccolo.webp",                            
          ],
          itemDesktopSmall: [
            "/images/listItem/customizedProjects/Amulets/Desktop/Piccolo/130x130px/Lussopack-Packaging-Customized-Projects-Amulets-Piccolo.webp",
          ],
          itemMobileBig: [
            "/images/listItem/customizedProjects/Amulets/Mobile/Piccolo/335x335px/Lussopack-Packaging-Customized-Projects-Amulets-Piccolo.webp",
          ],
          itemMobileSmall: [
            "/images/listItem/customizedProjects/Amulets/Mobile/Piccolo/100x100px/Lussopack-Packaging-Customized-Projects-Amulets-Piccolo.webp",
          ],
        }
      ],
    },
  ];
  